const move = <Type>(arr: Type[], fromIdx: number, toIdx: number) => {
  const newArr = [...arr];
  newArr.splice(toIdx, 0, newArr.splice(fromIdx, 1)[0]);
  return newArr;
};

export default move;
